import React, { FC } from 'react';
import { Link } from 'react-router-dom';
import Button from '../../components/ui/Button';

const CancellationRefunds: FC = () => {
  return (
    <div className="min-h-screen bg-gradient-to-br from-primary-teaGreen/5 via-white to-primary-lightGreen/10">
      {/* Hero Section */}
      <section className="relative pt-20 pb-16 md:pt-24 md:pb-20 overflow-hidden">
        {/* Background Decorations */}
        <div className="absolute inset-0 overflow-hidden">
          <div className="absolute -top-40 -right-40 w-80 h-80 bg-primary-teaGreen/20 rounded-full blur-3xl"></div>
          <div className="absolute -bottom-40 -left-40 w-80 h-80 bg-primary-lightGreen/20 rounded-full blur-3xl"></div>
        </div>

        <div className="relative max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center">
            <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold text-primary-black mb-6 leading-tight">
              Cancellation & Refunds
            </h1>
            <p className="text-lg md:text-xl text-gray-600 max-w-2xl mx-auto mb-8 leading-relaxed">
              At AMPS DHOONDH RECRUITMENT LLP ("Dhoondh"), we are committed to providing transparent and fair policies for our users.
            </p>
            <p className="text-sm text-gray-500">
              Last updated: January 2025
            </p>
          </div>
        </div>
      </section>

      {/* Content Section */}
      <section className="relative pb-20 md:pb-32">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="bg-white/80 backdrop-blur-sm rounded-3xl p-8 md:p-12 shadow-xl border border-gray-100">
            
            {/* Eligibility for Refunds */}
            <div className="mb-8">
              <h2 className="text-2xl font-bold text-primary-black mb-4">Eligibility for Refunds</h2>
              <ul className="list-disc list-inside text-gray-700 space-y-2">
                <li>Refunds apply only to job seekers who have enrolled in Dhoondh's paid employment services (currently INR 199).</li>
                <li>If we are unable to secure employment within six (6) months from the date of payment, you may be eligible for a full refund.</li>
              </ul>
            </div>

            {/* Refund Request Process */}
            <div className="mb-8">
              <h2 className="text-2xl font-bold text-primary-black mb-4">Refund Request Process</h2>
              <ol className="list-decimal list-inside text-gray-700 space-y-2">
                <li>Submit a formal refund request in writing via email or ticket system.</li>
                <li>Include relevant payment details and proof of non-placement.</li>
                <li>Requests must be filed within 30 days after the expiration of the 6-month placement period.</li>
              </ol>
              <div className="mt-4 p-4 bg-primary-teaGreen/10 rounded-lg">
                <p className="text-gray-700 text-sm">
                  <strong>Example:</strong> If your placement period ends on 31st May 2025, the refund request must be received by 30th June 2025.
                </p>
              </div>
            </div>

            {/* Refund Approval */}
            <div className="mb-8">
              <h2 className="text-2xl font-bold text-primary-black mb-4">Refund Approval</h2>
              <ul className="list-disc list-inside text-gray-700 space-y-2">
                <li>Refunds are approved only if Dhoondh, after reasonable efforts, is unable to place you within the stipulated period.</li>
                <li>Each refund request is reviewed on a case-by-case basis.</li>
              </ul>
            </div>

            {/* Non-Refundable Fees */}
            <div className="mb-8">
              <h2 className="text-2xl font-bold text-primary-black mb-4">Non-Refundable Fees</h2>
              <ul className="list-disc list-inside text-gray-700 space-y-2">
                <li>Resume/CV creation services (e.g., INR 99 resume-building support).</li>
                <li>Any administrative fees or processing charges incurred during the hiring process.</li>
                <li>If the job seeker accepts an employment offer during the 6-month period.</li>
                <li>Refunds requested outside the eligibility criteria or after the deadline.</li>
              </ul>
            </div>

            {/* Refund Timeline */}
            <div className="mb-8">
              <h2 className="text-2xl font-bold text-primary-black mb-4">Refund Timeline</h2>
              <ul className="list-disc list-inside text-gray-700 space-y-2">
                <li>Approved refunds are processed within 30 days of approval.</li>
                <li>Refunds are credited only to the original method of payment.</li>
                <li>Additional documentation may be required to complete the refund.</li>
              </ul>
            </div>

            {/* Limitation of Liability */}
            <div className="mb-8">
              <h2 className="text-2xl font-bold text-primary-black mb-4">Limitation of Liability</h2>
              <ul className="list-disc list-inside text-gray-700 space-y-2">
                <li>Dhoondh is not liable for any consequential, incidental, or indirect damages resulting from employment outcomes.</li>
                <li>The refund policy covers only the original service fee paid by the job seeker.</li>
              </ul>
            </div>

            {/* Contact Information */}
            <div className="mb-8">
              <h2 className="text-2xl font-bold text-primary-black mb-4">Contact Us</h2>
              <p className="text-gray-700 mb-4">
                If you have any questions about our Cancellation & Refunds policy, please contact us:
              </p>
              <div className="bg-primary-teaGreen/10 rounded-xl p-6">
                <p className="text-gray-700 mb-2">
                  <strong>Email:</strong> operations@dhoondh.in
                </p>
                <p className="text-gray-700 mb-2">
                  <strong>Phone:</strong> +91 93168 46322
                </p>
                <p className="text-gray-700">
                  <strong>Address:</strong>
                    510, Serene Centrum
                    Laxmipura, Vadodara – 390021
                </p>
              </div>
            </div>

            {/* Back to Home */}
            <div className="text-center pt-8 border-t border-gray-200">
              <Link to="/">
                <Button variant="outline" size="lg">
                  Back to Home
                </Button>
              </Link>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default CancellationRefunds;
